import { render, staticRenderFns } from "./CompanyCustomerModal.vue?vue&type=template&id=0153e153&scoped=true"
import script from "./CompanyCustomerModal.vue?vue&type=script&lang=js"
export * from "./CompanyCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyCustomerModal.vue?vue&type=style&index=0&id=0153e153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153e153",
  null
  
)

export default component.exports